import Icon from '@tiger/icons';
import { FC, ReactNode } from 'react';
import { MobileContentProps as BaseProps } from 'components/Picker';
import classlist from 'utils/classlist';
import styles from './style.scss';

interface MobileContentProps extends BaseProps {
    className?: string;
    title?: ReactNode;
}

const MobileContent: FC<MobileContentProps> = ({
    title = __('Please Select'),
    className,
    options = [],
    value = [],
    onChange,
    onDismiss
}) => {
    const handleSelectedRef = (node: HTMLDivElement | null) => {
        if (node) {
            // 滚动到可视区域
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };

    return (
        <div className={classlist(styles.mobileRoot, className)}>
            <div className={styles.header}>
                <h4 className={styles.title}>{title}</h4>
                <Icon className="fs-5" type="close" onClick={() => onDismiss?.()} />
            </div>
            <div className={styles.options}>
                {options.map(option => {
                    const isActive = value[0] === option.value;

                    return (
                        <div
                            key={option.value}
                            className={styles.option}
                            ref={isActive ? handleSelectedRef : null}
                            onClick={() => {
                                onChange?.([option.value], true);
                            }}>
                            {option.label}
                            {isActive && <Icon type="check" />}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileContent;
